
import EntidadeService from "@/services/sie-pedidos/entidade.service";
import {router} from "@/router";
import AuthService from "@/services/sie-pedidos/auth.service";
import FunctionsCommuns from "@/util/FunctionsCommuns";

export default{
  computed: {
    FunctionsCommuns() {
      return FunctionsCommuns
    }
  },
  mounted() {
    this.search();
  },
  data: () => ({
    headers: [
      { text: 'Situação', value: 'situacaoLote' },
      { text: 'Empresa', value: 'empresaUsuarioLote' },
      { text: 'Usúario', value: 'nomeUsuarioLote' },
      { text: 'Data', value: 'dataLote' },
    ],
    items: [],
    sortBy: 'dataLote',
    sortDesc: true,
    loading: false,
    numeroDoLote: router.currentRoute.params.id
  }),

  methods: {
    search() {
      EntidadeService.getListHistoricoLote(router.currentRoute.params.id).subscribe((response)=>{
        if(response['message']){
          AuthService.globalStore('error', response['message'])
        }else{
          const result = response['result'];
          this.items = result?.listHistoricoLote
        }
      }, (error)=>{
      })
    },
    voltar(){
      router.push("/carteira-macrorregiao/entidade/lotes/")
    }
  }
}
